import React from 'react';
import { ClockIcon, FilesIcon, HelpCircleIcon, RouteIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { problems } from '../data/content';
const ICONS = [FilesIcon, HelpCircleIcon, RouteIcon, ClockIcon];
export function ProblemSection() {
  return <section aria-labelledby="problema" className="bg-white text-noche" data-id="element-128" data-mp="2vqhh2ecujw0x">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-129" data-mp="2vp6e2gr86sav">
        <p className="inline-block rounded-md bg-noche px-2 py-0.5 font-sub text-sm font-extrabold text-oro" data-id="element-130" data-mp="39gkwomh80rhe">
          ¿Te suena familiar?
        </p>
        <h2 id="problema" className="mt-2 font-display text-[1.55rem] uppercase leading-[1.1] tracking-wide sm:text-4xl" data-id="element-131" data-mp="3jg1zmw538r9o">
          Quieres entender química, pero las fórmulas, los cálculos y tantos
          temas diferentes{' '}
          <span className="bg-oro px-1 text-noche" data-id="element-132" data-mp="1p2kk9weu70pq">
            hacen que no sepas por dónde empezar.
          </span>
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-snug text-noche/80" data-id="element-133" data-mp="1k5aolz0utstg">
          Si estás estudiando química, preparando un examen o necesitas enseñar
          sus contenidos, probablemente conozcas alguna de estas situaciones:
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-134" data-mp="sd0585nwoacz">
          {problems.map((problem, i) => {
          const Icon = ICONS[i];
          return <Reveal key={problem.title} as="li" delay={i * 0.03} className="flex h-full gap-2.5 rounded-xl border-2 border-noche bg-ciencia-light p-2.5 text-left" data-id="element-135" data-mp="123lagby34d4v" data-mpi={i}>
                <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-naranja text-white" aria-hidden="true" data-id="element-136" data-mp="1c33uesdzvywx">
                  <Icon size={16} data-id="element-137" data-mp="3dugxdbwejwqc" />
                </span>
                <div data-id="element-138" data-mp="3huhb0ubog3wc">
                  <h3 className="font-sub text-sm font-extrabold leading-tight" data-id="element-139" data-mp="3htz8xh2c2vgi">
                    {problem.title}
                  </h3>
                  <p className="mt-0.5 text-xs leading-snug text-noche/80 sm:text-sm" data-id="element-140" data-mp="p0is1hvnbllt">
                    {problem.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}